(function () {
    if (window.location.pathname !== '/') {
        return;
    }

    // CONFIG
    const LOGO_SRC = '/themes/custom/gula_gula/resources/images/logo.svg';
    const LOGO_SIZE = 340; // px
    const DENSITY = .5; // How many logos per 100px of movement

    // Relative offsets (based on 300px original reference)
    const offsetXRatio = (LOGO_SIZE - 145) / LOGO_SIZE;
    const offsetYRatio = -30 / LOGO_SIZE;

    // Accessibility checks
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const pointerFine = window.matchMedia('(pointer: fine)').matches; // skip on coarse (touch) if desired

    if (prefersReducedMotion || !pointerFine) {
        console.log('Logo trail effect disabled due to accessibility preferences.');
        return; // Skip the whole effect
    }

    // Create canvas
    const canvas = document.createElement('canvas');
    canvas.id = 'trailCanvas';
    document.body.appendChild(canvas);

    const ctx = canvas.getContext('2d', { alpha: true });

    function resizeCanvas() {
        const dpr = Math.max(1, window.devicePixelRatio || 1);
        const w = Math.ceil(window.innerWidth);
        const h = Math.ceil(window.innerHeight);
        canvas.width = w * dpr;
        canvas.height = h * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    window.addEventListener('resize', resizeCanvas, { passive: true });
    resizeCanvas();

    // Load logo
    const logo = new Image();
    logo.src = LOGO_SRC;
    logo.crossOrigin = 'anonymous';
    let logoReady = false;
    logo.onload = () => { logoReady = true; };

    function drawFallback(x, y, size) {
        ctx.beginPath();
        ctx.arc(x, y, size / 2, 0, Math.PI * 2);
        ctx.fillStyle = '#fff';
        ctx.fill();
    }

    function drawLogoAt(x, y) {
        const offsetX = LOGO_SIZE * offsetXRatio;
        const offsetY = LOGO_SIZE * offsetYRatio;

        if (logoReady) {
            ctx.drawImage(logo, x - offsetX, y + offsetY, LOGO_SIZE, LOGO_SIZE);
        } else {
            drawFallback(x - offsetX, y + offsetY, LOGO_SIZE);
        }
    }

    let lastPos = null;
    function paintTrailTo(x, y) {
        if (!lastPos) {
            drawLogoAt(x, y);
            lastPos = { x, y };
            return;
        }
        const dx = x - lastPos.x;
        const dy = y - lastPos.y;
        const dist = Math.hypot(dx, dy);

        const step = Math.max(1, Math.floor(LOGO_SIZE * DENSITY));
        const steps = Math.ceil(dist / step);

        for (let i = 1; i <= steps; i++) {
            const t = i / steps;
            drawLogoAt(lastPos.x + dx * t, lastPos.y + dy * t);
        }

        lastPos = { x, y };
    }

    function handlePointerMove(e) {
        const x = e.clientX ?? (e.touches?.[0]?.clientX);
        const y = e.clientY ?? (e.touches?.[0]?.clientY);
        if (x == null || y == null) return;
        paintTrailTo(x, y);
    }

    function handlePointerLeave() {
        lastPos = null;
    }

    window.addEventListener('pointermove', handlePointerMove, { passive: true });
    window.addEventListener('pointerleave', handlePointerLeave, { passive: true });
    window.addEventListener('pointercancel', handlePointerLeave, { passive: true });
    window.addEventListener('mouseout', handlePointerLeave, { passive: true });

    // Optional clear for debugging
    window._clearLogoTrail = function () {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        lastPos = null;
    };
})();
